import * as tslib_1 from "tslib";
import { NearDirectionalShadowMapper } from "@awayjs/scene";
import { ShadowCompositeMethod } from "./ShadowCompositeMethod";
// TODO: shadow mappers references in materials should be an interface so that this class should NOT extend ShadowMapMethodBase just for some delegation work
/**
 * ShadowNearMethod provides a shadow map method that restricts the shadowed area near the camera to optimize
 * shadow map usage. This method needs to be used in conjunction with a NearDirectionalShadowMapper.
 *
 * @see away.lights.NearDirectionalShadowMapper
 */
var ShadowNearMethod = (function (_super) {
    tslib_1.__extends(ShadowNearMethod, _super);
    /**
     * Creates a new ShadowNearMethod object.
     * @param baseMethod The shadow map sampling method used to sample individual cascades (fe: ShadowHardMethod, ShadowSoftMethod)
     * @param fadeRatio The amount of shadow fading to the outer shadow area. A value of 1 would mean the shadows start fading from the camera's near plane.
     */
    function ShadowNearMethod(baseMethod, fadeRatio) {
        if (baseMethod === void 0) { baseMethod = null; }
        if (fadeRatio === void 0) { fadeRatio = .1; }
        var _this = _super.call(this, baseMethod) || this;
        _this._fadeRatio = fadeRatio;
        if (!(baseMethod.castingLight.shadowMapper instanceof NearDirectionalShadowMapper))
            throw new Error("ShadowNearMethod requires a light that has a NearDirectionalShadowMapper instance assigned to shadowMapper.");
        return _this;
    }
    Object.defineProperty(ShadowNearMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return ShadowNearMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShadowNearMethod.prototype, "fadeRatio", {
        /**
         * The amount of shadow fading to the outer shadow area. A value of 1 would mean the shadows start fading from the camera's near plane.
         */
        get: function () {
            return this._fadeRatio;
        },
        set: function (value) {
            this._fadeRatio = value;
        },
        enumerable: true,
        configurable: true
    });
    return ShadowNearMethod;
}(ShadowCompositeMethod));
export { ShadowNearMethod };
ShadowNearMethod.assetType = "[asset ShadowNearMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/ShadowNearMethod.js